import { useEffect, useRef } from "react";

// A tiny bus from shell-level UI (the Ctrl+K command palette) to MailPage,
// which owns compose, folder selection and the shortcuts dialog. A command
// sent while MailPage isn't mounted (e.g. from Calendar) is kept until it
// mounts after the palette navigates to /mail.

export type MailCommand =
    | { type: "compose" }
    | { type: "folder"; id: string }
    | { type: "shortcuts" };

const EVENT = "mail:command";
let pending: MailCommand | null = null;

export function dispatchMailCommand(command: MailCommand) {
    pending = command;
    window.dispatchEvent(new CustomEvent(EVENT));
}

/** MailPage: run commands sent to it, including one queued before it mounted. */
export function useMailCommands(handler: (command: MailCommand) => void) {
    const ref = useRef(handler);
    ref.current = handler;
    useEffect(() => {
        const consume = () => {
            const command = pending;
            if (!command) return;
            pending = null;
            ref.current(command);
        };
        consume();
        window.addEventListener(EVENT, consume);
        return () => window.removeEventListener(EVENT, consume);
    }, []);
}
